import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch } from "../../lib/api";

export const useMediaLibrary = (enabled = true) => {
  const queryClient = useQueryClient();
  const mediaQuery = useQuery({ queryKey: ["admin-media"], queryFn: () => apiFetch("/admin/media"), enabled });
  const uploadMutation = useMutation({
    mutationFn: async (file) => { const body = new FormData(); body.append("file", file); return apiFetch("/admin/media", { method: "POST", body }); },
    onSuccess: (asset) => { queryClient.setQueryData(["admin-media"], (current = []) => [asset, ...current.filter((item) => item.asset_id !== asset.asset_id)]); queryClient.invalidateQueries({ queryKey: ["admin-media"] }); },
    onError: (error) => toast.error(error.message),
  });
  const updateMutation = useMutation({
    mutationFn: ({ assetId, metadata }) => apiFetch(`/admin/media/${assetId}`, { method: "PUT", body: JSON.stringify(metadata) }),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ["admin-media"] }); toast.success("Image details saved"); },
    onError: (error) => toast.error(error.message),
  });
  return { assets: mediaQuery.data || [], isLoading: mediaQuery.isLoading, uploadFile: uploadMutation.mutateAsync, uploading: uploadMutation.isPending, updateAsset: updateMutation.mutateAsync, updating: updateMutation.isPending };
};